/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');
    if (!this.container) {
      return;
    }
    this.form = this.container.querySelector('form.searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector('.side-panel-content--initial');
    this.predictiveSearchResults = this.container.querySelector('.side-panel-content--has-tabs');
    this.headerForm = document.querySelector('.header-search-field__form');
    this.headerInput = this.headerForm ? this.headerForm.querySelector('input[type="search"]') : null;
    this.headerResults = document.querySelector('[data-header-predictive-results]');

    this.setupEventListeners();
  }

  setupEventListeners() {
    if (this.form) {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    }

    if (this.input) {
      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
    }

    if (this.headerInput && this.headerResults) {
      this.headerForm.addEventListener('submit', this.onInlineFormSubmit.bind(this));
      this.headerInput.addEventListener('input', debounce(() => {
        this.onInlineChange();
      }, 300).bind(this));
      this.headerInput.addEventListener('focus', () => {
        if (this.headerInput.value.trim().length) {
          this.onInlineChange();
        }
      });
      document.addEventListener('click', (event) => {
        if (!event.target.closest('.header-search-field')) {
          this.closeInline();
        }
      });
    }

    this.button.forEach((item, i) => {
      item.addEventListener('click', (event) => {
        var _this = this;
        event.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
        if (this.container.classList.contains('active')) {
          setTimeout(function () {
            _this.input.focus({
              preventScroll: true
            });
          }, 100);
          dispatchCustomEvent('search:open');
        }

        return false;
      });
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove('active');
      return;
    }
    this.predictiveSearchResults.classList.add('active');
    this.getSearchResults(searchTerm, this.predictiveSearchResults, this.form);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onInlineFormSubmit(event) {
    if (!this.headerInput.value.trim().length) {
      event.preventDefault();
    }
  }

  onInlineChange() {
    const searchTerm = this.headerInput.value.trim();

    if (!searchTerm.length) {
      this.closeInline();
      return;
    }

    this.headerResults.classList.add('active');
    this.headerInput.setAttribute('aria-expanded', true);
    this.getSearchResults(searchTerm, this.headerResults, this.headerForm);
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm, target = this.predictiveSearchResults, form = this.form) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    target.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,page,article&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`)
      .then((response) => {
        target.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults(resultsMarkup, target, form);
      })
      .catch((error) => {
        target.classList.remove('loading');
        throw error;
      });
  }

  renderSearchResults(resultsMarkup, target = this.predictiveSearchResults, form = this.form) {
    target.innerHTML = resultsMarkup;

    let _this = this,
      submitButton = target.querySelector('[data-search-results-submit], #search-results-submit');


    if (submitButton && form) {
      submitButton.addEventListener('click', () => {
        form.submit();
      });
    }
  }

  close() {
    this.container.classList.remove('active');
  }

  closeInline() {
    if (!this.headerResults) {
      return;
    }
    this.headerResults.classList.remove('active');
    this.headerResults.classList.remove('loading');
    this.headerResults.innerHTML = '';
    if (this.headerInput) {
      this.headerInput.setAttribute('aria-expanded', false);
    }
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});
